import './App.css';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import i18n from './utilities/i18n';
import AuthProvider from './components/Auth/AuthProvider';
import { store } from './store/store';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router/dom';
import Router from './Router';
import { defaultQueryClientOptions } from './api/apiUtilities';

function App() {
  const queryClient = new QueryClient(defaultQueryClientOptions);

  return (
    <div
      className='App'
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100dvh' }}
    >
      <Provider store={store}>
        <I18nextProvider i18n={i18n()}>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <HelmetProvider>
                <RouterProvider router={Router} />
              </HelmetProvider>
            </AuthProvider>
          </QueryClientProvider>
        </I18nextProvider>
      </Provider>
    </div>
  );
}

export default App;
